export default __webpack_public_path__ + "static/media/banner-easter-l.5895058a.png";